import { AbstractService } from '@uniqoders/sdk';

export default class SettingsService extends AbstractService {
  /**
   * Retrieve CMS settings for an agency
   */
  public getCmsSettings(agency: string, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/settings', { agency }),
      params,
      headers,
    });
  }

  /**
   * Update CMS settings for an agency
   */
  public updateCmsSettings(agency: string, data: Record<string, any>, options: Record<string, any> = {}): Promise<any> {
    const { headers } = options;
    return this.request({
      method: 'patch',
      url: this.buildPath('/v2/{agency}/cms/settings', { agency }),
      data,
      headers,
    });
  }
}

